/**
 * Unit conversion utilities
 */

/**
 * Convert wind speed from meters/second to miles/hour
 * @param {number} v - Wind speed in m/s
 * @returns {number} Wind speed in mph
 */
export function windmsTomph(v) {
  return v * 2.23694;
}

/**
 * Convert precipitation from millimeters to inches
 * @param {number} v - Precipitation in mm
 * @returns {number} Precipitation in inches
 */
export function precipmmToin(v) {
  return v / 25.4;
}

/**
 * Convert temperature from Celsius to Fahrenheit
 * @param {number} v - Temperature in Celsius
 * @returns {number} Temperature in Fahrenheit
 */
export function tempCtoF(v) {
  return (v * 9/5) + 32;
}

/**
 * Convert distance from kilometers to miles
 * @param {number} v - Distance in km
 * @returns {number} Distance in miles (rounded)
 */
export function kmToMi(v) {
  return Math.round(v / 1.60934);
}
